import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

export const getTodosAPI = async () => {
  try {
    const res = await axiosInstance.get("/get_todo");
    return res.data.tasks;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const addTodoAPI = async (task) => {
  try {
    const res = await axiosInstance.get("/manage_todo", { params: { action: 'add', task } });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const updateTodoAPI = async ({ taskId, task }) => {
  try {
    const res = await axiosInstance.get(`/manage_todo`, { params: { action: 'update', task_id: taskId, task } });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const deleteTodoAPI = async (taskId) => {
  try {
    const res = await axiosInstance.get(`/manage_todo`, { params: { action: 'remove', task_id: taskId } });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const toggleTodoStatusAPI = async ({ taskId, isChecked }) => {
  try {
    const res = await axiosInstance.get(`/manage_todo`, { params: { action: isChecked ? 'uncheck' : 'checked', task_id: taskId } });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
}; 